import React from 'react';

const Twitter = React.memo(({ color, ...props }) => <svg width="44" height="44" viewBox="0 0 44 44" {...props}>
    <circle cx="22" cy="22" r="22" style={{ fill: color }} />
    <path d="M34,16.13a8.93,8.93,0,0,1-2.59.71,4.54,4.54,0,0,0,2-2.51,9,9,0,0,1-2.87,1.1,4.51,4.51,0,0,0-7.8,3.11,4.59,4.59,0,0,0,.12,1,12.78,12.78,0,0,1-9.3-4.75A4.57,4.57,0,0,0,15,20.86a4.49,4.49,0,0,1-2-.57v.06a4.54,4.54,0,0,0,3.62,4.46,4.5,4.5,0,0,1-2,.08A4.52,4.52,0,0,0,18.79,28,9.07,9.07,0,0,1,12,30,12.82,12.82,0,0,0,31.76,19.07v-.59A9.14,9.14,0,0,0,34,16.13" style={{ fill: '#fff' }} />
</svg>);

export default Twitter;

Twitter.defaultProps = {
    width: '34px',
    height: '34px',
    color: '#00abef',
};